import { SET_PK_LIST } from '../src/assets/common/PK';
import * as types from './mutation-type';

export default {
  [types.PK_LIST](state, data) {
    state.pkList = data;
  },
  [types.CONFIRM_PK_LIST](state, data) {
    if (JSON.stringify(data) === '[]') {
      state.confirm_PK_list = data;
    } else {
      state.confirm_PK_list = SET_PK_LIST(data);
    }
  },
  [types.CHANGE_PK_LIST](state, rowData) {
    const PK_LIST = state.confirm_PK_list;
    for (let i = 0; i < PK_LIST.length; i++) {
      const item = PK_LIST[i];
      if (rowData.PRODUCT_CODE === item.PRODUCT_CODE) {
        item.PK_COUNT = rowData.CURRENT_COUNT;
        item.PK_WORTH = rowData.PK_WORTH;
        break;
      }
    }
    state.confirm_PK_list = PK_LIST;
  },
  [types.SET_PK_ID](state, id) {
    state.PK_ID = id;
  },
  [types.SET_PK_CODE](state, code) {
    state.PK_CODE = code;
  },
  // ------------------------------库存状态
  [types.SET_SHOW_KC](state, code) {
    state.SHOW_KC = code;
  },
  // ---------------------------------------出库分页
  [types.SET_STOCK_OUT_CONDITION](state, code) {
    state.STOCK_OUT_CONDITION = code;
  },
  [types.SET_STOCK_IN_CONDITION](state, code) {
    state.STOCK_IN_CONDITION = code;
  },
  [types.SET_SALE_PRICING_CONDITION](state, code) {
    state.SALE_PRICING_CONDITION = code;
  },
  // 进销存
  [types.SET_DEPOSIT_DATA_CONDITION](state, dataInfo) {
    state.DEPOSIT_DATA_CONDITION = dataInfo;
  },
  // ---------------------------------------结算管理
  // ---------------------------------------自录客户结算
  [types.SET_NEW_ORDER_SEARCH_DATA_CONDITION](state, dataInfo) {
    state.NEW_ORDER_SEARCH_DATA_CONDITION = dataInfo;
  },
  // ---------------------------------------团餐公司结算
  [types.SET_ORDER_LIST_SEARCH_CONDITION](state, dataInfo) {
    state.ORDER_LIST_SEARCH_CONDITION = dataInfo;
  },
  // ---------------------------------------供应商结算
  [types.SET_READY_SEARCH_DATA_CONDITION](state, dataInfo) {
    state.READY_SEARCH_DATA_CONDITION = dataInfo;
  },
  // -----------------------------------自录客户结算列表
  [types.SET_ORDER_LIST_CONDITION](state, dataInfo) {
    state.ORDER_LIST_CONDITION = dataInfo;
  },
  // -----------------------------------供应商结算列表
  [types.SET_GYS_ORDER_LIST_CONDITION](state, dataInfo) {
    state.GYS_ORDER_LIST_CONDITION = dataInfo;
  },
  // -----------------------------------团餐结算列表
  [types.SET_TC_ORDER_LIST_CONDITION](state, dataInfo) {
    state.TC_ORDER_LIST_CONDITION = dataInfo;
  },
  // ------------------------------------销售订单--录入订单
  [types.SET_ENTRY_SEARCH_DATA_CONDITION](state, dataInfo) {
    state.ENTRY_SEARCH_DATA_CONDITION = dataInfo;
  },
  // ------------------------------------销售订单--待确认--项目点
  [types.SET_XMD_CONFIRM_SEARCH_DATA_CONDITION](state, dataInfo) {
    state.XMD_CONFIRM_SEARCH_DATA_CONDITION = dataInfo;
  },
  // ------------------------------------销售订单--待确认--供应商
  [types.SET_CONFIRM_SEARCH_DATA_CONDITION](state, dataInfo) {
    state.CONFIRM_SEARCH_DATA_CONDITION = dataInfo;
  },
  // ------------------------------------销售订单--待确认
  [types.SET_HISTORY_SEARCH_DATA_CONDITION](state, dataInfo) {
    state.HISTORY_SEARCH_DATA_CONDITION = dataInfo;
  },
  [types.SET_ALL_SEARCH_DATA_CONDITION](state, dataInfo) {
    state.ALL_SEARCH_DATA_CONDITION = dataInfo;
  },
  // ------------------------------------销售订单--订单查询
  [types.SET_SERACH_SELL_ORDER_DATA_CONDITION](state, dataInfo) {
    state.SERACH_SELL_ORDER_DATA_CONDITION = dataInfo;
  },

  // ------------------------------------采购订单--待送
  [types.SET_NEWORDER_SEARCH_DATA_CONDITION](state, dataInfo) {
    state.NEWORDER_SEARCH_DATA_CONDITION = dataInfo;
  },
  // ------------------------------------采购订单--历史
  [types.SET_NEWORDER_HISTORY_DATA_CONDITION](state, dataInfo) {
    state.NEWORDER_HISTORY_DATA_CONDITION = dataInfo;
  },

  [types.SET_SAVE_OTHER_PANENAME](state, dataInfo) {
    state.SAVE_OTHER_PANENAME = dataInfo;
  },
  // ------------------------------------报表--出库单
  [types.SET_HISTORY_OUT_DATA_CONDITION](state, dataInfo) {
    state.HISTORY_OUT_DATA_CONDITION = dataInfo;
  },
  [types.SET_HISTORY_IN_DATA_CONDITION](state, dataInfo) {
    state.HISTORY_IN_DATA_CONDITION = dataInfo;
  },
  // ------------------------------------销售订单----新增产品
  [types.SET_NEW_ADD_ORDER_CONDITION](state, dataInfo) {
    state.NEW_ADD_ORDER_CONDITION = dataInfo;
  },
  // --------------------------------------供应商管理---新增产品
  [types.SET_GYS_ADD_ORDER_CONDITION](state, dataInfo) {
    state.GYS_ADD_ORDER_CONDITION = dataInfo;
  },
  // ---------------------------------------记住密码
  [types.SET_ACC_INFO](state, dataInfo) {
    state.ACC_INFO = dataInfo;
  },
  // ---------------------------------------采买单
  [types.SET_CMD_INFO_CONDITION](state, dataInfo) {
    state.CMD_INFO = dataInfo;
  },
  // ---------------------------------------面板撞状态
  [types.SET_SAVE_PANENAME](state, dataInfo) {
    state.SAVE_PANENAME = dataInfo;
  },
  [types.SET_SAVE_STOCKLIST](state, dataInfo) {
    state.SAVE_STOCKLIST = dataInfo;
  },
  [types.SET_SAVE_DSORDER_LIST](state, dataInfo) {
    state.SAVE_DSORDER_LIST = dataInfo;
  },
  [types.SET_SAVE_QUALIFIC_LIST](state, dataInfo) {
    state.SAVE_QUALIFIC_LIST = dataInfo;
  },
  [types.TAB_SALES_DATE](state, dataInfo) {
    state.TAB_SALES_DATE = dataInfo;
  },
  [types.SET_PURCHASE_SEARCH](state, dataInfo) {
    state.PURCHASE_SEARCH = dataInfo;
  },
  // -----------------------------------------2021.4.7分出 分菜单管理
  [types.SET_SORT_SEARCH](state, dataInfo) {
    state.SORT_SEARCH = dataInfo;
  },
  // --------------------------------------------领料单
  [types.SET_SAVE_PICKING_DOC](state, dataInfo) {
    state.SAVE_PICKING_DOC = dataInfo;
  },
  // --------------------------------------------生产领料单
  [types.SET_SAVE_PRO_PICKING_DOC](state, dataInfo) {
    state.SAVE_PRO_PICKING_DOC = dataInfo;
  },
  // --------------------------------------------生产入库
  [types.SET_SAVE_PRO_WAREHOUSING](state, dataInfo) {
    state.SAVE_PRO_WAREHOUSING = dataInfo;
  },
  // --------------------------------------------生产入库单
  [types.SET_SAVE_PRO_RECEIPT](state, dataInfo) {
    state.SAVE_PRO_RECEIPT = dataInfo;
  },
  // --------------------------------------------客户列表
  [types.SET_SAVE_CUSTOMER_LIST](state, dataInfo) {
    state.SAVE_CUSTOMER_LIST = dataInfo;
  },
  // ----------------------------------------------供应商管理
  [types.SET_SUPPLIER_LIST](state, dataInfo) {
    state.SUPPLIER_LIST = dataInfo;
  },
  // ---------------------------------生产配置管理
  [types.SET_PRODUCTION_LIST](state, dataInfo) {
    state.PRODUCTION_LIST = dataInfo;
  },
  // --------------------------------------出库汇总单
  [types.SET_TOTAL_OUT_DOC_LIST](state, dataInfo) {
    state.TOTAL_OUT_DOC_LIST = dataInfo;
  },
  // 销售订单 ----》打印标签
  [types.S_PRINT_ALL](state, dataInfo) {
    state.S_PRINT_ALL = dataInfo;
  },
  // 报表 -------》每日剩余库存表
  [types.DAILYINVENTORY_ALL](state, dataInfo) {
    state.DAILYINVENTORY_ALL = dataInfo;
  },
  // 报表 -------》盘库盈亏表
  [types.PROFITLOSSTABLE_ALL](state, dataInfo) {
    state.PROFITLOSSTABLE_ALL = dataInfo;
  },
  // 报表 -------》销售退库单
  [types.RETURNWAREHOUSE_ALL](state, dataInfo) {
    state.RETURNWAREHOUSE_ALL = dataInfo;
  },
  // 报表 -------》销售退货单
  [types.RETURNGOODS_ALL](state, dataInfo) {
    state.RETURNGOODS_ALL = dataInfo;
  },
  // 报表 -------》采购退货单
  [types.RETURNPRODUCT_ALL](state, dataInfo) {
    state.RETURNPRODUCT_ALL = dataInfo;
  },
  // 报表 -------》销售报表
  [types.SALESSTATEMENTS_ALL](state, dataInfo) {
    state.SALESSTATEMENTS_ALL = dataInfo;
  },
  // 报表 -------》毛利报表
  [types.GROSSPROFIT_ALL](state, dataInfo) {
    state.GROSSPROFIT_ALL = dataInfo;
  },
  // 报表 -------》采购报表
  [types.PURCHASE_ALL](state, dataInfo) {
    state.PURCHASE_ALL = dataInfo;
  },
  // 报表 -------》进销存报表
  [types.TOTALDEPOSITPURCHASE_ALL](state, dataInfo) {
    state.TOTALDEPOSITPURCHASE_ALL = dataInfo;
  },
  // 报表 -------》客户毛利表
  [types.TCGROSSPROFIT_ALL](state, { dataInfo }) {
    state.TCGROSSPROFIT_ALL = dataInfo;
  },
  // 报表 -------》销售退货单
  [types.SELLORDERRETURN_ALL](state, { dataInfo }) {
    state.SELLORDERRETURN_ALL = dataInfo;
  },
  // 报表 -------》采购价格变化趋势
  [types.PRICECHANGECHART_ALL](state, { dataInfo }) {
    state.PRICECHANGECHART_ALL = dataInfo;
  },
  // 报表 -------》商品销售排行
  [types.PRODUCTRANKLIST_ALL](state, { dataInfo }) {
    state.PRODUCTRANKLIST_ALL = dataInfo;
  },
  // 报表 -------》总仓单品毛利表
  [types.SINGLERANGE_ALL](state, { dataInfo }) {
    state.SINGLERANGE_ALL = dataInfo;
  },
  // 仓库管理->盘库筛选条件记录
  [types.SET_INVENTORY_SEARCH](state, dataInfo) {
    state.INVENTORY_SEARCH = dataInfo;
  },
  // 人员管理
  [types.SET_PERSON_MANAGE_DATA_CONDITION](state, dataInfo) {
    state.PERSON_MANAGE_DATA_CONDITION = dataInfo;
  },
  // 库位
  [types.SET_POSITION_CONDITION](state, dataInfo) {
    state.POSITION_CONDITION = dataInfo;
  },
  // 一类
  [types.SET_FIRST_CATEGORY_DATA_CONDITION](state, dataInfo) {
    state.FIRST_CATEGORY_DATA_CONDITION = dataInfo;
  },
  // 二类
  [types.SET_SECOND_CATEGORY_DATA_CONDITION](state, dataInfo) {
    state.SECOND_CATEGORY_DATA_CONDITION = dataInfo;
  },
  // 在用SKU管理
  [types.SET_SKU_USED_DATA_CONDITION](state, dataInfo) {
    state.SKU_USED_DATA_CONDITION = dataInfo;
  },
  // 采购产品
  [types.SET_ADD_BTN_TO_PROJECT](state, status) {
    state.isAddBtnToProduct = status;
  },
  // 采购订单待确认订单
  [types.SET_CONFIRM_DATA_CONDITION](state, dataInfo) {
    state.CONFIRM_DATA_CONDITION = dataInfo;
  },
  [types.SET_CONFIRM_DATA_CONDITION_S](state, dataInfo) {
    state.CONFIRM_DATA_CONDITION_S = dataInfo;
  },
  // WMS-临时仓
  [types.SET_WMS_TEMPORARYSTOCK_CONDITION](state, dataInfo) {
    state.WMS_TEMPORARYSTOCK_CONDITION = dataInfo;
  },
  // WMS-库存预警
  [types.SET_WMS_STOCKWARNING_CONDITION](state, dataInfo) {
    state.WMS_STOCKWARNING_CONDITION = dataInfo;
  },
  // 拣货单界面
  [types.SET_PICKINGLIST_CONDITION](state, dataInfo) {
    state.PICKINGLIST_CONDITION = dataInfo;
  },
  // 价格管理-客户定价复核
  [types.SET_CUSTOMER_PRICING_REVIEW_CONDITION](state, dataInfo) {
    state.CUSTOMER_PRICING_REVIEW_CONDITION = dataInfo;
  },
  // 销售订单管理-销售价复核
  [types.SET_SALES_PRICE_REVIEW_CONDITION](state, dataInfo) {
    state.SALES_PRICE_REVIEW_CONDITION = dataInfo;
  },
  // 产品管理-产品税率-供应商税率设置
  [types.SET_SUPPLIERTAX_DATA_CONDITION](state, dataInfo) {
    state.SUPPLIERTAX_DATA_CONDITION = dataInfo;
  },
  // 报表-送货差异表
  [types.SET_DELIVERY_DISCREPANCY_DATA_CONDITION](state, dataInfo) {
    state.DELIVERY_DISCREPANCY_DATA_CONDITION = dataInfo;
  },
  // 分拣配送-分拣组管理
  [types.SET_SORTING_GROUP_MANAGEMENT_CONDITION](state, dataInfo) {
    state.SORTING_GROUP_MANAGEMENT_CONDITION = dataInfo;
  },
  // 财务中心-发票列表
  [types.SET_INVOICE_LIST_DATA_CONDITION](state, dataInfo) {
    state.INVOICE_LIST_DATA_CONDITION = dataInfo;
  },
  // 分拣配送-周转筐管理
  [types.SET_TURNOVER_MANAGE_DATA_CONDITION](state, dataInfo) {
    state.TURNOVER_MANAGE_DATA_CONDITION = dataInfo;
  },
  // 价格管理-销售价格查询
  [types.SET_SALES_PRICE_INQUIRY_CONDITION](state, dataInfo) {
    state.SALES_PRICE_INQUIRY_CONDITION = dataInfo;
  },
  // 价格管理-采购价格查询
  [types.SET_PURCHASE_PRICE_INQUIRY_CONDITION](state, dataInfo) {
    state.PURCHASE_PRICE_INQUIRY_CONDITION = dataInfo;
  },
  // 第三方配送订单-转换订单
  [types.SET_SUPPLIER_SEND_ORDER_CONDITION](state, dataInfo) {
    state.SUPPLIER_SEND_ORDER_CONDITION = dataInfo;
  },
  // 第三方配送订单-历史订单
  [types.SET_DSHISTORY_ORDER_LIST_CONDITION](state, dataInfo) {
    state.DSHISTORY_ORDER_LIST_CONDITION = dataInfo;
  },
  // 第三方配送订单-待送订单
  [types.SET_DS_ORDER_LIST_CONDITION](state, dataInfo) {
    state.DS_ORDER_LIST_CONDITION = dataInfo;
  },
  // 第三方配送订单-待确认订单
  [types.SET_DS_ORDER_CONFIRM_LIST_CONDITION](state, dataInfo) {
    state.DS_ORDER_CONFIRM_LIST_CONDITION = dataInfo;
  },
  // 食品安全-采购品资质下载
  [types.SET_PURCHASE_QUALIFICATION_DOWNLOAD_LIST](state, dataInfo) {
    state.PURCHASE_QUALIFICATION_DOWNLOAD_LIST = dataInfo;
  },
  // 食品安全-采购品资质下载详情
  [types.SET_PURCHASE_QUALIFICATION_DOWNLOAD_DETAIL_LIST](state, dataInfo) {
    state.PURCHASE_QUALIFICATION_DOWNLOAD_DETAIL_LIST = dataInfo;
  },
  // 报表-业务部毛利表
  [types.SET_BUSINESS_GROSS_PROFIT_TABLE](state, dataInfo) {
    state.BUSINESS_GROSS_PROFIT_TABLE = dataInfo;
  },
  // 报表-仓库收发明细表
  [types.SET_WAREHOUSE_TRANSCEIVER_CONDITION](state, dataInfo) {
    state.WAREHOUSE_TRANSCEIVER_CONDITION = dataInfo;
  },
  // 报表-采购部差价表
  [types.SET_PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION](state, dataInfo) {
    state.PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION = dataInfo;
  },
  // 销售订单管理-订单调价申请记录
  [types.SET_PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION](state, dataInfo) {
    state.PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION = dataInfo;
  },
  // 财务中心-客户结算-供应商客户
  SET_SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION(state, dataInfo) {
    state.SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION = dataInfo;
  },
  // 销售订单管理-单外订单
  SET_LOW_PRICE_ORDER_LIST(state, dataInfo) {
    state.LOW_PRICE_ORDER_LIST = dataInfo;
  },

  // 报表-项目销售日汇总表
  SET_PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION(state, dataInfo) {
    state.PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION = dataInfo;
  },
  // ----------------------------报表--销售退货单
  设置销售退货单存储数据(state, dataInfo) {
    state.销售退货单存储数据 = dataInfo;
  },
  设置分拣差异查询存储数据(state, dataInfo) {
    state.分拣差异查询存储数据 = dataInfo;
  },
  设置第三方供货关系管理存储数据(state, dataInfo) {
    state.第三方供货关系管理存储数据 = dataInfo;
  },
  设置销售订单待送订单存储数据(state, dataInfo) {
    state.销售订单待送订单存储数据 = dataInfo;
  },

  设置采购报表存储数据(state, dataInfo) {
    state.采购报表存储数据 = dataInfo;
  },
  设置进货台账存储数据(state, dataInfo) {
    state.进货台账存储数据 = dataInfo;
  },
  // 仓库管理-出库验收差异
  保存出库验收差异筛选条件(state, dataInfo) {
    state.出库验收差异筛选条件 = dataInfo;
  },
  // 报表-订单产品毛利表
  保存订单产品毛利表筛选记忆(state, dataInfo) {
    state.订单产品毛利表筛选记忆 = dataInfo;
  },
  // 预约处理-设置未读列表
  SET_UNREAD_INFORMATION_LIST(state, dataInfo) {
    state.UNREAD_INFORMATION_LIST = [...dataInfo];
  },
  // 预约处理-添加到未读列表
  ADD_TO_UNREAD_INFORMATION_LIST(state, dataInfo) {
    state.UNREAD_INFORMATION_LIST.push(dataInfo);
  },
  // 预约处理-从未读列表删除
  DELETE_FROM_UNREAD_INFORMATION_LIST(state, dataInfo) {
    state.UNREAD_INFORMATION_LIST = [...state.UNREAD_INFORMATION_LIST.filter((item) => item.ID != dataInfo.ID)];
  },
  // 预约处理-设置预约下载定时器ID
  SET_APPOINTMENT_INTERVAL_ID(state, dataInfo) {
    state.APPOINTMENT_INTERVAL_ID = dataInfo;
  },

  保存供应商快捷结算筛选记忆(state, dataInfo) {
    state.供应商快捷结算筛选记忆 = dataInfo;
  },
  SET_ITEM_SALES_SCHEDULE(state, dataInfo) {
    state.ITEM_SALES_SCHEDULE = dataInfo;
  },
  SET_DS_ORDER_INQUIRY_DATA_CONDITION(state, dataInfo) {
    state.DS_ORDER_INQUIRY_DATA_CONDITION = dataInfo;
  },
  SET_DELIVERY_TASK_PROGRESS(state, dataInfo) {
    state.DELIVERY_TASK_PROGRESS = dataInfo;
  },
  [types.SET_STOCK_ENTER_DETAIL](state, dataInfo) {
    state.stock_enter_detail = dataInfo;
  },
  [types.SET_DS_UNPRICE_ORDER_DETAIL_CONDITION](state, dataInfo) {
    state.DS_UNPRICE_ORDER_DETAIL_CONDITION = dataInfo;
  },
};




//////////////////
// WEBPACK FOOTER
// ./store/mutation.js
// module id = null
// module chunks = 